import { Vue, Component, Ref } from 'vue-property-decorator'
import ConfigurationSectionHeader from '@/modules/configurationModule/ConfigurationSectionHeader.vue'
import VtGrid from '@/components/VtGrid/VtGrid.vue'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import GridDisplayOptions from '@/components/GridDisplayOptions.vue'
import { GetContextMenuItemsParams, GridOptions, MenuItemDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import GroupsOfConceptsModalBasicForm from '@/modules/configurationModule/detail/accounting/non-billable/groups-of-concepts/components/groups-of-concepts-modal-basic-form/groups-of-concepts-modal-basic-form.vue'
import ConfigurationSidepanel from '@/modules/configurationModule/detail/ConfigurationSidepanel.vue'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

@Component({
    components: {
        ConfigurationSectionHeader,
        VtGrid,
        GridDisplayOptions,
        GroupsOfConceptsModalBasicForm,
        ConfigurationSidepanel
    }
})
export default class GroupsOfConceptsGrid extends Vue {
    @Ref() readonly groupsOfConceptsModalBasicForm!: any

    private actionTitle !: string
    private selectedRows !: Array<object>
    private rowData!: Array<object>
    private columnDefs!: Array<object>
    private gridApi !: any
    private showSidepanel !: boolean
    private sidepanelTitle !: string
    private selectedUnitRates !: Array<object>

    constructor() {
        super()
        this.actionTitle = ''
        this.selectedRows = []
        this.columnDefs = [
            { type: 'customCheckbox' },
            {
                type: 'text',
                headerName: i18n.tc('configuration.sections.groupOfConcepts', 1),
                colId: 'groupOfConcept',
                field: 'groupOfConcept',
                minWidth: 250,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.t('configuration.grid.code'),
                colId: 'code',
                field: 'code',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'checkIconRenderer',
                headerName: i18n.t('configuration.grid.active'),
                colId: 'active',
                field: 'active',
                minWidth: 80,
                suppressSizeToFit: true
            }
        ]
        this.rowData = [
            {
                groupOfConcept: 'BIOPSIA O PIEZA QUIRÚRGICA-GRUPO 1',
                code: '001',
                active: true
            },
            {
                groupOfConcept: 'BIOPSIA O PIEZA QUIRÚRGICA-GRUPO 2',
                code: '002',
                active: true
            },
            {
                groupOfConcept: 'BIOPSIA O PIEZA QUIRÚRGICA-GRUPO 3',
                code: '003',
                active: true
            }
        ]
        this.gridApi = null
        this.showSidepanel = false
        this.sidepanelTitle = ''
    }

    get gridOptions(): GridOptions {
        return {
            sideBar: gridSideBarConfig,
            rowModelType: AgGridRowModelType.CLIENT_SIDE,
            getContextMenuItems: this.getContextMenuItems,
            onGridReady: params => {
                this.onGridReady(params)
            },
            onRowSelected: params => {
                this.onRowSelected()
            },
            onRowClicked: params => {
                this.onRowClickedSidepanel()
                this.sidepanelTitle = params?.node.data.groupOfConcept
            }
        }
    }

    getContextMenuItems(params: GetContextMenuItemsParams): MenuItemDef[] {
        if (!params?.node) {
            return []
        } else {
            return [
                {
                    name: this.$t('configuration.actions.update').toString()
                },
                {
                    name: this.$t('configuration.actions.delete').toString()
                },
                {
                    name: this.$t('configuration.actions.activate').toString()
                },
                {
                    name: this.$t('configuration.actions.deactivate').toString()
                }
            ]
        }
    }

    onRowSelected() {
        this.selectedRows = this.gridApi.getSelectedRows()
    }

    onGridReady({ api }: any) {
        this.gridApi = api
    }

    onRowClickedSidepanel() {
        this.showSidepanel = true
    }

    showGroupOfConceptModalBasicForm(title: string) {
        this.actionTitle = title
        this.groupsOfConceptsModalBasicForm.show()
    }

    // TODO: Mejorar esto en Front
    async deleteGroupOfConcept() {
        await this.$_showConfirmationModal(`${this.$t('configuration.grid.deleteConfirmation')} ${this.selectedRows.length} ${this.$tc('configuration.grid.element', this.selectedRows.length)}, <br/> ${this.$t('configuration.grid.deleteQuestion')}`, this.$t('configuration.actions.delete').toString())
    }
}
